import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteProjectsProjectIDDocumentsProjectDocumentID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PROJECTS_QUERY_KEYS } from "Projects/Api/Queries/queryKeys";

export function useDeleteProjectDocumentMutation(projectID: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((projectDocumentID: string) =>
      deleteProjectsProjectIDDocumentsProjectDocumentID(
        projectID,
        projectDocumentID,
      ),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.documents(projectID),
      });
    },
  });
}
